module.exports = __webpack_public_path__ + "static/img/enterpriseb.422702f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterpriseb.jpg
// module id = O5iJ
// module chunks = 1